<template>
    <tr>
    <td><b class="font-weight-bold">{{new Date(item.date).toLocaleDateString("en-GB")}} </b></td>
    <td></td>
    <td v-if="!item.isCredited"><b class="green--text font-weight-bold">  {{item.totalAmount || 0 | amount }} </b></td>
    <td v-if="!item.isCredited"></td>
    <td v-if="item.isCredited"></td>
    <td v-if="item.isCredited"><b class="red--text font-weight-bold">  {{item.totalAmount || 0 | amount }} </b></td>
    <td><b class="font-weight-bold"> {{getVocherType(item)}} </b></td>
    <td ><b class="font-weight-bold">{{item.paymentType}}</b></td>
    <td ><b class="font-weight-bold" v-if ='item.accountNumber'> {{item.transferType || item.transactionType}} </b></td>
    <td ><b  class="font-weight-bold"> {{item.remark}} </b></td>
    </tr>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
const mapBuyerGetters = createNamespacedHelpers('Buyer')['mapGetters']

export default {
        props:{
            item:{
                type:Object,
                default: () => {
                    return {}
                }
            },
            firms: {
                type: Array,
                default: []
            },
            isCredited: {
                type: Boolean,
                default: true
            }, 
        },
        data: () => ({
            expenseById:{},
            liabilityById:{},
            bankAccountById: {},
            incomeById:{},
            staffById:{},
            assetById:{},
        }),
        created () {
            this.$bindAsArray(
                'accounts',
                this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)
            )
            this.$bindAsObject(
                'bankAccountById',
                this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)
            )
            this.$bindAsObject(
                'expenseById',
                this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand)
            )
            this.$bindAsObject(
                'liabilityById',
                this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand)
            )
            this.$bindAsObject(
                'incomeById',
                this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand)
            )
            this.$bindAsObject(
                'assetById',
                this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand)
            )
            this.$bindAsObject(
                'staffById',
                this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)
            )
        },
        computed:{
            ...mapGlobalGetters(['selectedBrand']),
        },
        methods: {
            updateInvoice (invoiceId, firmId) {
                let updatedInvoice = this.invoicesById[invoiceId]
                updatedInvoice['firm'] = firmId
                this.$root.$firebaseRefs.invoice.child(invoiceId).set(updatedInvoice)
            },
            firmNameById (id) {
                let firm = this.firms.filter(item=> item['.key'] == id)[0]
                if (firm) {
                    return firm['name']
                }
            },
            expenseNameById (id) {
                if(this.expenseById[id]){
                    return this.expenseById[id]['expense']
                }
            },
            liabilityNameById (id) {
                if(this.liabilityById[id]){
                    return this.liabilityById[id]['liability']
                }
            },
            bankAccountNameById (id) {
                if(this.bankAccountById[id]){
                    return this.bankAccountById[id]['bankName']
                }
            },
            incomeNameById (id) {
                if(this.incomeById[id]){
                    return this.incomeById[id]['income']
                }
            },
            assetNameById (id) {
                if(this.assetById[id]){
                    return this.assetById[id]['asset']
                }
            },
            staffNameById (id) {
                if(this.staffById[id]){
                    return this.staffById[id]['staffName']
                }
            },
            getNumberOfDaysFromStartDate (createdAt, closedDate) {
                console.log (createdAt, closedDate)
                const startDate = DateTime.fromMillis(createdAt)
                if(!closedDate) {
                    closedDate = DateTime.local()
                } else {
                    closedDate = DateTime.fromMillis(closedDate)
                }
                const endDate = closedDate
                const interval = Interval.fromDateTimes(startDate, endDate)
                return Number.parseInt(interval.length('days'))
            },
            getTotalAmount (principal, rate, createdAt) {
                const time = this.getNumberOfDaysFromStartDate(createdAt) / 365
                rate = rate * 12 / 100
                return Number.parseFloat(principal * (1 + (rate * time))).toFixed(2)
            },
            getInterestValue (principal, rate, createdAt) {
                return (this.getTotalAmount(principal, rate, createdAt) - Number.parseFloat(principal)).toFixed(2)
            },
            getVocherType(invoice) {
            if (invoice.return) {
                if (invoice.isBuyer) {
                return "Credit Note";
                } else {
                return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (
                invoice["type"] == "automatic invoice" &&
                invoice.transactionType === "Transfer"
            ) {
                return "Transfer";
            } 
            else if (
                (invoice.transactionType != "Debit" && invoice["type"] === "Advance") ||
                invoice["type"] === "Opening Balance" ||
                invoice["type"] === "LoanGiven" || 
                invoice["type"] === "LoanTaken" ||
                invoice["type"] === "Security"
            ) {
                return invoice["type"];
            } 
            else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } 
            else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            }
            else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            }
            else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            }
            else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            }
            else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Firms/automaticInvoice.vue